__turbopack_context__.v({
  "className": "outfit_808ae0ce-module__U_2mtq__className",
  "variable": "outfit_808ae0ce-module__U_2mtq__variable",
});
